export function GlobalRoles() {
    return <h2>Global Roles</h2>;
}
